'use client';

import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { NewsType } from '@/api/config/types';
import { GameType } from '@/api/services/GameService/types';
import GlobalService from '@/api/services/GlobalService';
import GameCard from '@/app/[lang]/(web)/products/games/components/GameCard';
import Image from '@/components/core/Image';
import YouTubePlayer from '@/components/core/YouTubePlayer';
import Features from '@/components/pages/Home/Features';
import { useTranslation } from '@/hooks/useTranslations';
import monoPolyImg1 from '@/public/assets/Images/monopoly/monopoly-img1.png';
import monoPolyImg2 from '@/public/assets/Images/monopoly/monopoly-img2.png';
import monoPolyImg4 from '@/public/assets/Images/monopoly/monopoly-img4.png';
import monoPolyImg5 from '@/public/assets/Images/monopoly/monopoly-img5.png';
import monoPolyMakingImg1 from '@/public/assets/Images/monopoly/poly-making-img1.png';
import monoPolyMakingImg2 from '@/public/assets/Images/monopoly/poly-making-img2.png';
import monoPolyMakingImg3 from '@/public/assets/Images/monopoly/poly-making-img3.png';
import monoPolyMakingImg4 from '@/public/assets/Images/monopoly/poly-making-img4.png';
import monoPolyMakingImg5 from '@/public/assets/Images/monopoly/poly-making-img5.png';
import monoPolyMakingImg6 from '@/public/assets/Images/monopoly/poly-making-img6.png';

import './styles.scss';

const Poly = () => {
  const params = useParams();
  const { t } = useTranslation();

  const [polyGames, setPolyGames] = useState<GameType[] | []>([]);
  const [polyNews, setPolyNews] = useState<NewsType[] | []>([]);

  useEffect(() => {
    GlobalService.getData<GameType>('GAME_URL_FRONT', {
      page: 1,
      category: '',
      lang: params.lang,
      brand: 2,
    }).then((data) => {
      if (data?.query) {
        setPolyGames(data.query);
      }
    });

    GlobalService.getData<NewsType>('NEWS_URL_FRONT', {
      lang: params.lang,
      brand: 2,
    }).then((data) => {
      if (data?.query) {
        setPolyNews(data.query);
      }
    });
  }, [params.lang]);

  return (
    <div className="monopoly-wrp">
      <div className="monopoly-top-block" id="aboutPoly">
        <div className="monopoly-top-img-wrp">
          <div className="monopoly-top-img left">
            <Image src={monoPolyImg1} alt="" />
          </div>
          <div className="monopoly-top-img right">
            <Image src={monoPolyImg2} alt="" />
          </div>
        </div>
        <h1 className="polyPageTitle monopoly-making-poly-title">{t('Poly-Title')}</h1>
        <div dangerouslySetInnerHTML={{ __html: t('Poly-Desc') }} className="monopoly-top-img-txt" />
      </div>
      <div className="monopoly-meets-gaming-block">
        <div className="monopoly-meets-gaming-holder">
          <div className="monopoly-meets-gaming-inner">
            <h2 className="monopoly-meets-gaming-txt">{t('Poly-Whereartmeetsgaming')}</h2>
          </div>
        </div>
      </div>
      <div className="bigContent">
        <div className="monopoly-exclusive-live-wrp" id="liveCasino">
          <div className="monopoly-exclusive-live-left">
            <div className="monopoly-exclusive-live-left-inner">
              <YouTubePlayer videoId="pnlVIJnr3lE" width="100%" height="100%" />
            </div>
          </div>
          <div className="monopoly-exclusive-live-right">
            <h2 className="monopoly-exclusive-live-right-title">
              {t('Poly-Title-Livecasinogames')}
            </h2>
            <p className="monopoly-exclusive-live-right-txt">{t('Poly-Desc-Livecasinogames')}</p>
            <div className="monopoly-exclusive-live-game-wrp">
              {polyGames
                .filter(({ categorySlug }: GameType) => categorySlug === 'live-casino')
                .map((game: GameType) => (
                  <GameCard game={game} key={game.id} />
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="monopoly-making-poly-wrp">
        <div className="monopoly-making-poly-info">
          <h2 className="monopoly-making-poly-title">{t('Poly-BTS-Title')}</h2>
          <p className="monopoly-making-poly-info-txt">{t('Poly-BTS-Desc')}</p>
        </div>
        <div className="monopoly-making-img-block">
          <div className="monopoly-making-img-holder">
            <div className="monopoly-making-img-inner">
              <div className="monopoly-making-img-wrp type1">
                <Image src={monoPolyMakingImg1} className="monopoly-making-img" alt="" />
              </div>
              <div className="monopoly-making-img-wrp type2">
                <Image src={monoPolyMakingImg2} className="monopoly-making-img" alt="" />
              </div>
              <div className="monopoly-making-img-wrp type3">
                <Image src={monoPolyMakingImg3} className="monopoly-making-img" alt="" />
              </div>
              <div className="monopoly-making-img-wrp type4">
                <Image src={monoPolyMakingImg4} className="monopoly-making-img" alt="" />
              </div>
              <div className="monopoly-making-img-wrp type5">
                <Image src={monoPolyMakingImg5} className="monopoly-making-img" alt="" />
              </div>
              <div className="monopoly-making-img-wrp type6">
                <Image src={monoPolyMakingImg6} className="monopoly-making-img" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="monopoly-poly-slot" id="slots">
        <span className="monopoly-poly-slot-blur-block type1"></span>
        <span className="monopoly-poly-slot-blur-block type2"></span>
        <div className="monopoly-poly-slot-inner">
          <div className="monopoly-poly-slot-inner-left">
            <Image className="monopoly-poly-slot-inner-img" src={monoPolyImg4} alt="" />
          </div>
          <div className="monopoly-poly-slot-inner-center">
            <h2 className="monopoly-poly-slot-title">{t('Poly-Slots-Title')}</h2>
            <p className="monopoly-poly-slot-subtxt">{t('Poly-Slots-Desc')}</p>
            <div className="monopoly-poly-slot-money-img-block">
              {polyGames
                .filter(({ categorySlug }: GameType) => categorySlug === 'slots')
                .map((game: GameType) => (
                  <GameCard game={game} key={game.id} />
                ))}
            </div>
          </div>
          <div className="monopoly-poly-slot-inner-right">
            <Image className="monopoly-poly-slot-inner-img" src={monoPolyImg5} alt="" />
          </div>
        </div>
      </div>

      <div className="monopoly-poly-news-wrp" id="news">
        <Features
          title="Poly-News&updates-title"
          news={polyNews}
          description="Poly-News&updates-desc"
        />
      </div>
    </div>
  );
};

export default Poly;
